import { useContext } from 'react';
import { AuthContext } from '../services/authContext';
import { Navigate } from 'react-router-dom';
import ServiceLeadAdmin from '../components/modules/admin/ServiceLeadAdmin';
import AdminAdmin from '../components/modules/admin/AdminAdmin';
import '../scss/components/admin.scss';

const Admin = () => {
    const { isLoggedIn, userProfile, userRoles } = useContext(AuthContext);

    if (!isLoggedIn || !userProfile) {
        return <Navigate to="/" />;
    }

    return (

        <div id="Admin" className="screen">
            {userRoles.includes('Admin') ? (
                <AdminAdmin />
            ) : userRoles.includes('Service Lead') ? (
                <ServiceLeadAdmin />
            ) : (
                <p className="text-center">You do not have access to this section.</p>
            )}
        </div>
    );
};

export default Admin;
